import React from 'react';

function ForgotPasswordDialogHeader() {
  return (
    <div className="forgot-password-dialog__header">
      <h4>Password recovery</h4>
    </div>
  );
}
export default ForgotPasswordDialogHeader;
